import { useTrackedChanges } from './useTrackedChanges'

interface Props {
  articleKey: string
  layerId: string
  id: string
}

export const useTrackedChange = ({ articleKey, layerId, id }: Props) => {
  const { data } = useTrackedChanges({ articleKey, layerId })
  if (!data) {
    return null
  }
  return data.tracked_changes.find((tc) => tc.id === id)
}
